const authentication = 'https://karma.propelld.com/api/api-gateway/propelld/sdk/auth';
const application = 'https://karma.propelld.com/api/api-gateway/propelld/sdk/application';
const staticdata = 'https://karma.propelld.com/api/api-gateway/propelld/sdk/static';
const documents = 'https://karma.propelld.com/api/resources';
const staticData = 'https://karma.propelld.com/api/'
const baseUrls = {
    authentication,
    application,
    staticdata,
    documents,
    staticData
};

export default baseUrls;
